import { isAppError } from "@/api/problems";
import { useT } from "@/i18n";

/**
 * The sentence a failure is shown as.
 *
 * The server's own `message` when it sent one, printed exactly as sent
 * (Rachel, 21-09-2026: error wording, and its language, are the backend's).
 * Our table speaks only when the server did not: no answer, an empty body, or
 * something that is not an AppError at all. A server error
 * carries its trace id either way, so the reader has something to quote.
 */
export function useErrorText(): (error: unknown) => string {
  const { t } = useT();
  return (error) => {
    if (!isAppError(error)) return t("error.unknown");
    const words = error.serverMessage ?? t(error.messageKey);
    return error.kind === "server" && error.traceId
      ? `${words} ${t("error.reference", { traceId: error.traceId })}`
      : words;
  };
}
